"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEST_NET_CHAIN_ID = exports.MAIN_NET_CHAIN_ID = exports.ADDRESS_LENGTH = exports.SIGNATURE_LENGTH = exports.PRIVATE_KEY_LENGTH = exports.PUBLIC_KEY_LENGTH = void 0;
exports.PUBLIC_KEY_LENGTH = 32;
exports.PRIVATE_KEY_LENGTH = 32;
exports.SIGNATURE_LENGTH = 64;
exports.ADDRESS_LENGTH = 26;
exports.MAIN_NET_CHAIN_ID = 87; // W
exports.TEST_NET_CHAIN_ID = 84; // T
//# sourceMappingURL=interface.js.map